module.exports = __webpack_public_path__ + "img/car.f4e4cb9c.png";